// import VModal from 'vue-js-modal';

/**
 * 初始化基础组件，将window挂载进来
 */
const HYCOMPONENTS = [];
const context = require.context('./', true, /(index.js|index.web.js)$/);
context.keys().forEach((key) => {
  const comp = context(key);
  comp.default && HYCOMPONENTS.push(comp);
});

export default {
  install(Vue) {
    // 注入Modal外部组件
    // Vue.use(VModal, { componentName: 'v-modal' });
    HYCOMPONENTS.forEach((module) => {
      Object.values(module).forEach((comp) => {
        comp.name && comp.render && Vue.component(comp.name, comp);
      });
    });
  },
};
